export default "__VITE_ASSET__COLtw8an__"